import { State } from "@progress/kendo-data-query";
import { RefObject } from "react";
import ExcelExportButton from "./ExcelExportButton";

interface CreateExportButtonParams<TSource, TDestination> {
  url: string;
  filename: string;
  mapping?: (item: TSource) => TDestination;
}

export function createExportButton<TSource, TDestination>({
  url,
  filename,
  mapping,
}: CreateExportButtonParams<TSource, TDestination>) {
  return function ExportButton(dataState: State, { current }: RefObject<any>) {
    return (
      <ExcelExportButton
        key={url}
        url={url}
        dataState={dataState}
        columns={current?.columns.slice(0)}
        fileName={filename}
        exportMapping={mapping}
      />
    );
  };
}
